import React, { memo, useState, useEffect } from 'react';
import { Drawer, Card, Button, Icon } from '@material-ui/core';
import { UpdateIsView as UPDATE_ISVIEW } from 'Components/Api/NewsAPI';
import { CommisssionHoldByUserID as Commisssion_Hold_BY_USERID } from 'Components/Api/CommissionHoldAPI';
const CommisionHoldDisplay = ({ IsOpen, handlCommissionHoldPanel }) => {
    const [CommissionHoldList, setCommissionHoldList] = useState([]);

    useEffect(() => {
        if (IsOpen === true) GetCommissionHold();
    }, [IsOpen]);

    const GetCommissionHold = async () => {
        const response = await Commisssion_Hold_BY_USERID();
        if (!response.status) return;
        var data = JSON.parse(response.data);
        setCommissionHoldList(data);
    };

    const deleteNotification = async (NewsID) => {
        let n = CommissionHoldList.filter((news) => {
            return news.NewsID !== NewsID;
        });
        setCommissionHoldList(n);

        let jsonObj = {
            NewsID: NewsID
        };

        const response = await UPDATE_ISVIEW(JSON.stringify(jsonObj));

        if (!response.status) return;

        var data = JSON.parse(response.data);
        setCommissionHoldList(data);
    };

    const CommissionHold = CommissionHoldList.map(
        ({ WalletID, WalletName, Amount }) => (
            <div
                key={WalletID}
                className="notification__card position-relative"
                style={{ width: '255px' }}
            >
                <Card className="mx-4 mb-6" elevation={3}>
                    <div className="card__topbar flex items-center justify-between p-2 bg-light-gray">
                        <div className="flex items-center">
                            <div className="card__topbar__button">
                                <Icon
                                    className="card__topbar__icon"
                                    fontSize="small"
                                >
                                    currency_rupee
                                </Icon>
                            </div>
                            <span className="ml-4 font-medium text-muted"></span>
                        </div>
                    </div>
                    <div className="px-4 pt-2 pb-4">
                        <p className="m-0">{WalletName}</p>
                        <small className="text-muted">{Amount}</small>
                    </div>
                </Card>
            </div>
        )
    );

    const handleClearNotifications = () => {
        deleteNotification(99999);
    };

    const NotificationPanelTitle = (
        <div className="notification">
            <div className="notification__topbar flex items-center p-4 mb-4">
                <Icon color="primary">currency_rupee</Icon>
                <h5 className="ml-2 my-0 font-medium">Commission Hold</h5>
            </div>
        </div>
    );
    return (
        <Drawer
            variant="temporary"
            anchor={'right'}
            open={IsOpen}
            onClose={handlCommissionHoldPanel}
        >
            {NotificationPanelTitle}
            {!IsCommissionHoldPresent(CommissionHoldList)
                ? DefaultNotification
                : CommissionHold}

            {!IsCommissionHoldPresent(CommissionHoldList)
                ? null
                : handleClearNotifications()}
        </Drawer>
    );
};

function IsCommissionHoldPresent(News) {
    return News === [] ||
        News === null ||
        News === undefined ||
        News.length === 0
        ? false
        : true;
}

const DefaultNotification = (
    <div
        className="notification__card position-relative"
        style={{ width: '255px' }}
    >
        <Card className="mx-4 mb-6" elevation={3}>
            <div className="flex items-center">
                <div className="card__topbar__button">
                    <Icon className="card__topbar__icon" fontSize="small">
                        currency_rupee
                    </Icon>
                </div>
                <span className="ml-4 font-medium text-muted">
                    Commission Hold
                </span>
            </div>
            <div className="px-4 pt-2 pb-4">
                <small className="text-muted">No hold commission for you</small>
            </div>
        </Card>
    </div>
);

export default memo(CommisionHoldDisplay);
